module.exports = __webpack_public_path__ + "static/media/event_generic_pin.6d56fa4f.png";